import styled, { css } from "styled-components";

const getColorByVariant = (variant = 'rouse') => {
    switch (variant) {
        case 'rouse':
            return css`${({ theme }) => theme?.colors?.theme?.brandColor3}`;
        case 'green':
            return css`${({ theme }) => theme?.colors?.theme?.sucess}`;
        case 'white':
            return css`${({ theme }) => theme?.colors?.common?.white}`;
        case 'default':
            return css`${({ theme }) => theme?.colors?.text?.headings}`;
        default:
            return css`${({ theme }) => theme?.colors?.theme?.brandColor3}`;
    }
};

const SectionWithHeadingsStyled = styled.section`
	width: 100%;
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 32px;
	align-self: stretch;

	@media (max-width: 768px) {
		padding: 0;
	}
`;

const TitleStyled = styled.div<{ $titleColor?: string; $titleAlign?: string }>`
	width: 100%;
	color: ${({ $titleColor }) => getColorByVariant($titleColor)};
	font-size: 32px;
	font-style: normal;
	font-weight: 700;
	line-height: 150%;
	text-align: ${({ $titleAlign }) => $titleAlign || 'left'};
`;

const ContainerShowAndHide = styled.div<{ $endMission: boolean }>`
	width: 100%;
	${({ $endMission }) => $endMission ? css`
		display: none;
		height: 0px;
		overflow: hidden;
	` : css`
		display: block;
		height: auto;
		overflow: visible;
	`}
`;

export {
	SectionWithHeadingsStyled,
	TitleStyled,
	ContainerShowAndHide
}
